{{#if config.label}}
  {{> elements/_page_builder_label label=config.label description=config.description }}
{{/if}}
<div>
  <div class="collection-editor-container">
    {{#each context.items}}
      <div class="card card--flat collection-item" data-index="{{@key}}">
        <div class="collection-item__header">
          <label>
            <span class="collection-item__header-label"></span>
            <input type="number" class="collection-item__header-index" value="{{index @key}}" min="1" data-collection-editor-behaviour="reorder-input">
            {{#if this.title}}<span class="collection-item__header-title">{{{this.title}}}</span>{{/if}}
          </label>
          <sp-icon name="close-alt-color" class="card__remove-action" data-collection-editor-behaviour="remove-collection-item" data-index="{{@key}}">✕</sp-icon>
        </div>
        <div class="editor-fields-container"></div>
        <small class="tool-comment">Click to Edit. Drag & Drop to Reorganize.</small>
      </div>
    {{/each}}

    <div class="collection-item__add" data-collection-editor-behaviour="add-collection-item">
      {{{ icon 'add' }}}
    </div>
  </div>
</div>
<div class="customized shared-component-options">
  <a href="" class="reset">{{{ icon "close-alt-color" }}} Remove Override</a>
</div>
